import { render, staticRenderFns } from "./Handler.vue?vue&type=template&id=9da77f92&scoped=true&"
import script from "./Handler.vue?vue&type=script&lang=js&"
export * from "./Handler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da77f92",
  null
  
)

export default component.exports